export var PurchaseOrderApiErrorType;
(function (PurchaseOrderApiErrorType) {
    PurchaseOrderApiErrorType["PURCHASE_ORDER_NOT_FOUND_ERROR"] = "purchase-orders.errors.purchaseOrderNotFound";
    PurchaseOrderApiErrorType["OUTDATED_PURCHASE_ORDER_ERROR"] = "purchase-orders.errors.outdatedPurchaseOrderError";
    PurchaseOrderApiErrorType["PURCHASE_ORDER_INVALID_STATUS"] = "purchase-orders.errors.purchaseOrderInvalidStatus";
})(PurchaseOrderApiErrorType || (PurchaseOrderApiErrorType = {}));
//# sourceMappingURL=purchase-order.errors.js.map